import React from 'react';
import { Lock, Shield, Download, ShieldCheck, Headphones } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: Lock,
    text: 'Pagamento sicuro'
  }, {
    icon: Shield,
    text: 'Garanzia'
  }, {
    icon: Download,
    text: 'Download immediato'
  }, {
    icon: ShieldCheck,
    text: 'Protezione dati'
  }, {
    icon: Headphones,
    text: 'Supporto'
  }];
  return <div className="bg-gray-100 py-6 px-4 border-y border-gray-200" data-id="element-237">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-238">
        {items.map((item, i) => {
        const Icon = item.icon;
        return <div key={i} className="flex flex-col items-center text-gray-500" data-id="element-239">
              <Icon className="w-6 h-6 mb-2" data-id="element-240" />
              <span className="text-xs font-medium uppercase tracking-wider text-center" data-id="element-241">
                {item.text}
              </span>
            </div>;
      })}
      </div>
    </div>;
}